import { render, staticRenderFns } from "./CoordinateField.vue?vue&type=template&id=6effced3"
import script from "./CoordinateField.vue?vue&type=script&lang=js"
export * from "./CoordinateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports